import React from 'react';
import ChangeLandingPage from '../change/landing/ChangeLandingPage';

const UpgradeLandingPage = () => <ChangeLandingPage isUpgradePage />;

export default UpgradeLandingPage;
